/**
 * Alipay CN icon URL
 * China's popular mobile payment platform
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const ALIPAYCN_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/5EK8VF1nACmJ0KpPocLuR7/785178078004e82cb69782c570623b8c/Alipay.svg';
